module.exports = __webpack_public_path__ + "static/media/holding-phone-cutout.1676f4a9.png";